<template>
  <!-- 出荷準備詳細 -->
  <div id="HolterShippingDetail">
    <div id="container">
      <div class="labelTitle lable">ホルター心電図配送ｻｰﾋﾞｽ 出荷準備</div>
      <div class="button-area">
        <b-button
          class="backButton is-primary"
          @click="back"
        >戻る</b-button>
      </div>
      <div id="item-contens">
        <div class="card-content margin-top">
          <table>
            <tr><th>受付番号</th>
              <td>
                <span v-for="(num, index) in data.receiptNumber" :key="index"><span v-if="index >0"> , </span>{{num}}</span>
                <span v-if="data.depositMachineFlag" class="depo"/>
              </td>
            </tr>
            <tr><th>台数</th><td>{{data.units}}</td></tr>
            <tr><th>送り状番号<span class="require" /></th><td><input type="text" v-model="data.invoiceNumber" :disabled="!data.editFlag" maxlength="14"/></td></tr>
            <tr><th>着払い番号<span class="require" /></th><td><input type="text" v-model="data.paymentNumber" :disabled="!data.editFlag" maxlength="14"/></td></tr>
            <tr><th>配送先</th><td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">〒{{data.zip}} {{data.shippingAddress}}</td></tr>
            <tr><th>宛名</th><td>{{data.receiverName}}</td></tr>
            <tr><th>連絡先(電話番号)</th><td>{{data.phoneNumber}}</td></tr>
            <tr><th>出荷日</th><td>{{data.shippingDate}}</td></tr>
            <tr><th>WP300同梱の有無</th><td><span v-if="data.hstRequestFlag">有</span><span v-else>無</span></td></tr>
            <tr><th>パッチ/ロット①</th><td>{{data.patchlot1}}</td></tr>
            <tr><th>パッチ/ロット②</th><td>{{data.patchlot2}}</td></tr>
            <tr><th>パッチ/ロット③</th><td>{{data.patchlot3}}</td></tr>
            <tr v-if="!atLaunchHidden.hiddenFlag"><th>ワイヤー/ロット</th><td>{{data.leadPatch}}</td></tr>
            <tr><th>配達希望時間帯</th><td>{{data.desiredDeliveryTimeZone | getNameFilter(desiredDeliveryTimeZoneList)}}</td></tr>
            <tr>
              <th style="vertical-align:top;">患者備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.patientNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">配送備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.deliveryInformationNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">受付備考</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.receptionNote}}</td>
            </tr>
            <tr>
              <th style="vertical-align:top;">外部ユーザーコメント</th>
              <td style="word-break: break-word;white-space:pre-wrap;word-wrap:break-word;">{{data.belongsNote}}</td>
            </tr>
          </table>
        </div>
        <template v-for="(item, index) in data.deviceInfoList">
          <div class="card-content margin-top" :key="index">
            <span style="font-size:20px;">機器情報{{index+1}}</span>
            <table>
              <tr><th>受付番号</th><td>{{item.receiptNumber}}</td></tr>
              <tr><th>機種</th><td>{{item.modelId | getNameFilter(modelList) }}</td></tr>
              <tr><th>シリアルナンバー</th>
                <td style="width:280px;">{{item.serial}}</td>
                <td>
                  <b-button
                    style="width:150px;"
                    class="receptionistButton is-primary"
                    @click="returnPreparation(item.receiptNumber,item.serial)"
                    :disabled="!data.editFlag"
                  >機器準備中に戻す</b-button>
                </td>
              </tr>
              <tr><th>患者名</th><td>{{item.patientName}}</td></tr>
              <tr v-if="!atLaunchHidden.hiddenFlag"><th>リードワイヤーアダプター</th><td>(STEP2対応)</td></tr>
              <!-- TODO: STEP2対応
              -->
              <tr v-if="!atLaunchHidden.hiddenFlag"><th>フレックス電極</th><td>(STEP2対応)</td></tr>
              <!-- TODO: STEP2対応
              -->
            </table>
          </div>
        </template>
        <div class="button-area">
          <b-button
            class="receptionistButton is-primary"
            @click="registNumber"
            :disabled="!data.editFlag"
          >番号登録</b-button>
          <b-button
            class="receptionistButton is-primary"
            @click="doShipping(data.inspectionPeriod)"
            :disabled="!data.editFlag"
          >出荷済みにする</b-button>
          <b-button
            class="backButton is-primary"
            @click="back"
          >戻る</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {choicesType} from "@/components/mock/base/const.js";
import {LendingPeriod} from "@/components/mock/base/const.js";
import {atLaunchHidden} from "@/components/mock/base/const.js";
export default {
  name: "HolterShippingDetail",
  methods: {
    doSearch: function() {
      var excuteApi = this.getHolterDeviceShipmentDetailPOST;
      var successCallBack = this.getHolterDeviceShipmentDetailPOSTSuccess;
      var errorCallBack = this.getHolterDeviceShipmentDetailPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getHolterDeviceShipmentDetailPOST: function(client) {
      return client.apis.internalHolter.getHolterDeviceShipmentDetailPOST({
        body:{receiptNumber:this.targetNumber}
      });
    },
    getHolterDeviceShipmentDetailPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getHolterDeviceShipmentDetailPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result,this.back());
    },
    back: function() {
      this.$router.push({
        name: "HolterShippingList",
        params: { searchConditions: this.searchParams },
      });
    },
    registNumber: function() {
      if(!this.data.invoiceNumber && !this.data.paymentNumber){
        this.showErrorMessage("番号が入力されていません。")
        return
      }
      var excuteApi = this.setHolterNumberPOST;
      var successCallBack = this.setHolterNumberPOSTSuccess;
      var errorCallBack = this.setHolterNumberPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterNumberPOST: function(client) {
      var obj = []
      for(let item of this.data.deviceInfoList){
        var req = {
          receiptNumber: item.receiptNumber,
          invoiceNumber: this.data.invoiceNumber ? this.data.invoiceNumber : "",
          paymentNumber: this.data.paymentNumber ? this.data.paymentNumber : ""
        }
        obj.push(req)
      }
      return client.apis.internalHolter.setHolterNumberPOST({
        body: obj
      });
    },
    setHolterNumberPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setHolterNumberPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    doShipping: function(inspectionPeriod) {
      this.inspectionPeriod = inspectionPeriod
      if(!this.data.invoiceNumber || !this.data.paymentNumber){
        this.showErrorMessage("「送り状番号」「着払い番号」を入力してください。")
        return
      }

      var excuteApi = this.setHolterDeviceShipmentPOST;
      var successCallBack = this.setHolterDeviceShipmentPOSTSuccess;
      var errorCallBack = this.setHolterDeviceShipmentPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    setHolterDeviceShipmentPOST: function(client) {
      var lendingPeriod = LendingPeriod.holter_fourteen_period;
      var choicesInspectionPeriod = "";
      this.inspectionPeriodList.forEach(ele => {
        if (ele.value == this.inspectionPeriod){
          choicesInspectionPeriod = ele.label1
        }
      });
      if (choicesInspectionPeriod && choicesInspectionPeriod.match(/14日/)){
        lendingPeriod = LendingPeriod.holter_fourteen_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/10日/)){
        lendingPeriod = LendingPeriod.holter_tenday_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/5日/)){
        lendingPeriod = LendingPeriod.holter_fiveday_period;
      } else if (choicesInspectionPeriod && choicesInspectionPeriod.match(/24時間/)){
        lendingPeriod = LendingPeriod.holter_oneday_period;
      }

      var obj = []
      // 返却日の設定
      var returnDate = this.getBusinessDay(new Date(), lendingPeriod);
      returnDate = this.yyyy_sla_MM_sla_dd(returnDate)
      for(let item of this.data.deviceInfoList){
        var req = {
          receiptNumber: item.receiptNumber,
          invoiceNumber: this.data.invoiceNumber ? this.data.invoiceNumber : "",
          paymentNumber: this.data.paymentNumber ? this.data.paymentNumber : "",
          returnDate: returnDate
        }
        obj.push(req)
      }
      return client.apis.internalHolter.setHolterDeviceShipmentPOST({
        body: obj
      });
    },
    setHolterDeviceShipmentPOSTSuccess: function(result) {
      // 検索結果取得
      this.showSuccess(result,this.back());
    },
    setHolterDeviceShipmentPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    returnPreparation: function(receiptNumber,serial) {
      this.reqParams = {
        receiptNumber:receiptNumber,
        serial:serial
      }
      var messsage = "設定済みのシリアル及び送り状番号/着払い番号は解除されます。機器準備中に戻しますか？";
      this.$dialog.confirm({
        title: "解除確認",
        message:messsage,
        cancelText: "キャンセル",
        onConfirm: async () => {
          var excuteApi = this.setHolterDeviceShipmentReturnPOST;
          var successCallBack = this.setHolterDeviceShipmentReturnPOSTSuccess;
          var errorCallBack = this.setHolterDeviceShipmentReturnPOSTError;
          // WebAPI Call
          await this.apiCall(excuteApi, successCallBack, errorCallBack)
        }
      })
    },
    setHolterDeviceShipmentReturnPOST: function(client) {
      return client.apis.internalHolter.setHolterDeviceShipmentReturnPOST({
        body:this.reqParams
      });
    },
    setHolterDeviceShipmentReturnPOSTSuccess: function(result) {
      // 成功メッセージ表示
      this.showSuccess(result)
      if(this.data.deviceInfoList.length == 1){
        this.back()
        return
      }
      this.targetNumber = this.targetNumber.filter(val => val != this.reqParams.receiptNumber)
      this.reqParams.receiptNumber = ""
      this.reqParams.serial = ""
      this.doSearch();  //再検索
      this.jumpToTop(); //画面を上部に移動
    },
    setHolterDeviceShipmentReturnPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    }
  },
  data() {
    var targetNumber = this.$route.params["receiptNumber"];
    var searchParams = this.$route.params["searchConditions"];
    var modelList = this.getChoiceList(choicesType.holterKind, false);
    var desiredDeliveryTimeZoneList = this.getChoiceList(choicesType.deliveryTime, false);
    var inspectionPeriodList = this.getChoiceList(choicesType.holterInspectionPeriod, false);
    return {
      data: {},
      targetNumber,
      searchParams,
      modelList,
      desiredDeliveryTimeZoneList,
      atLaunchHidden: atLaunchHidden,
      inspectionPeriod: "",
      inspectionPeriodList: inspectionPeriodList,
    };
  },
  async mounted() {
    // 詳細情報取得
    await this.doSearch();
  },
  filters: {
    getNameFilter: function(val, list){
      var target = list.find(item => item.value == val)
      if(target){
        return target.label1
      }
      return ""
    }
  },
  components: {}
};
</script>
<style lang="scss" scoped>
table.flowTable,
table.flowTable tr,
table.flowTable td {
  border: 1px solid;
  padding: 0px;
  vertical-align: middle;
}
table.flowTable td {
  width: 40px;
  text-align: center;
}

.delay {
  font-weight: bold;
}
.delay,
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/holter/HolterShippingDetail.vue